var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"wrapper-1"},[_c('div',{staticClass:"wrapper-2"},[_c('h1',[_vm._v("Thank you !")]),_c('p',[_vm._v("Thanks for submitting the feedback. ")])])])])
}]

export { render, staticRenderFns }